import React, { Component } from 'react';
import { withStyles, typography } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Toolbar, Radio, FormControlLabel, Button, Checkbox, Icon, DialogActions, IconButton, AppBar, Dialog, DialogContent, Typography } from 'material-ui';
import ReactTable from "react-table";
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { TextFieldFormsy, CheckboxFormsy } from '@fuse';
import axios from 'axios';
import { withAlert } from 'react-alert';
import Loader from "other-components/loader/loader";
import 'react-select/dist/react-select.css'
import { confirmAlert } from 'react-confirm-alert';
import CloseIcon from '@material-ui/icons/Close';
import Select from 'react-select';
import { TextField } from 'material-ui';
import _ from "lodash";
import moment from 'moment';

class cashTransaction extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            dialogEdit: false,
            categoryEdit: {},
            cashBook: null,
            ledgerAccount: null,
            transactionData: {transactionDate: moment(new Date()).format("YYYY-MM-DD"),},
            spentData: [],
            recivedData: [],
            recivedDataOriginal: [],
            //transactionDate: moment(new Date()).format("YYYY-MM-DD")
            
        };

        // this.setSelectedJob = this.setSelectedJob.bind(this);
        this.clearState = this.clearState.bind(this);

    }

    loadLedgerAccounts = (id) => {

        this.setState({ loading: true });
        this.setState({ cashBookList: [] });
        this.setState({ draftId: null });
        var ledgerList = [];

        // axios.post('http://localhost:5009/ledgerAccount/getLedgerAccountForOpenningBalance',{'id':id})
        axios.post(window.accountServer + '/ledgerAccount/getLedgerAccountsByMainAccount', { 'id': id })
            .then(response => {

                for (let i = 0; i < response.data.ledgerAccountDetails.length; i++) {

                    ledgerList.push({
                        value: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                        label: response.data.ledgerAccountDetails[i].NAME
                    });
                }
                this.setState({ loading: false });
                if (id == 'all') {
                    this.setState({ ledgerAccounts: ledgerList });
                }
                else {
                    this.setState({ cashBookList: ledgerList });
                }

            }).catch(function (error) {
                console.log("err " + error);
            });
    }

    clearState() {
        this.setState({
            transactionData: {
                transactionCode: '',
                docNumber: '',
                transactionDate: moment(new Date()).format("YYYY-MM-DD"),
                referance: '',
                selectedRadio: null
            },
        });
    }

    handleRadioChange = event => {
        this.setState({ selectedRadio: event.target.value });
        var tmpArray = { ...this.state.transactionData };
        tmpArray['type'] = event.target.value;
        this.setState({ transactionData: tmpArray });
    };

    handleCashBook = (selectedOption) => {

        if (selectedOption) {

            this.setState({ cashBook: selectedOption });
            var tmpArray = { ...this.state.transactionData };
            tmpArray['cashBook'] = selectedOption;
            this.setState({ transactionData: tmpArray });
        }

        else {

            this.setState({ cashBook: null });
        }

    }

    handleLedgerAccount = (selectedOption) => {

        if (selectedOption) {

            this.setState({ ledgerAccount: selectedOption });
        }

        else {

            this.setState({ ledgerAccount: null });
        }

    }

    pushData = (data, element) => {

        var tmpArray = { ...this.state.transactionData };
        // var tmp = Object.assign(this.state.transactionData,{[element]:data.target.value}); 
        tmpArray[element] = data.target.value;
        this.setState({ transactionData: tmpArray });

    }

    addSpent = (data) => {

        if (data.ledgerAccount) {

            this.state.spentData.push(data);

            var tmpArray = { ...this.state.transactionData };
            tmpArray['spentData'] = this.state.spentData;
            this.setState({ transactionData: tmpArray });

            document.getElementById('spentForm').reset();
            this.setState({ ledgerAccount: null });
            console.log(this.state.transactionData);
        }

        else {

            this.props.alert.error("Select a Ledger Account to Add");
        }

    }

    addRecived = (data) => {

        if (data.ledgerAccount) {

            this.state.recivedData.push(Object.assign({}, data));
            this.state.recivedDataOriginal.push(Object.assign({}, data));

            var tmpArray = { ...this.state.transactionData };
            tmpArray['recivedData'] = this.state.recivedData;
            this.setState({ transactionData: tmpArray });

            document.getElementById('recievedForm').reset();
            this.setState({ ledgerAccount: null });
            console.log(this.state.transactionData);
        }

        else {

            this.props.alert.error("Select a Ledger Account to Add");
        }
    }

    roundUpSpentData = (data) => {

        console.log(data.target.value);

        var tmpArray = [...this.state.spentData];

        for (let i = 0; this.state.spentData.length > i; i++) {

            tmpArray[i].amount = Math.ceil(parseFloat(this.state.spentData[i].amount));
        }
        this.setState({ spentData: tmpArray });

        console.log(this.state.spentData);
    }

    roundUpRecievedData = (data) => {



        if (data.target.checked) {

            var tmpArray = [...this.state.recivedData];

            for (let i = 0; this.state.recivedData.length > i; i++) {

                tmpArray[i].amount = Math.ceil(parseFloat(this.state.recivedData[i].amount));
            }
            this.setState({ recivedData: tmpArray }, () => {

                console.log(this.state.recivedData);
                console.log(this.state.recivedDataOriginal);

            });
        }

        // else{

        //     var tmpArray = [...this.state.recivedDataOriginal];

        //     this.setState({ recivedData: tmpArray}, () => {

        //         console.log(this.state.recivedData);
        //         console.log(this.state.recivedDataOriginal);

        //     });


        // }


    }

    addTransaction = () => {

        if (this.state.transactionData.transactionDate && this.state.transactionData.cashBook && this.state.transactionData.type) {

            this.setState({ loading: true });

            axios.post(window.accountServer + '/ledgerAccount/addCashTransaction', this.state.transactionData)
            // axios.post('http://localhost:5009/ledgerAccount/addCashTransaction', this.state.transactionData)
                .then(res => {

                    if (res.data.status) {
                        this.setState({ transactionData: [] });
                        this.setState({ spentData: [] });
                        this.setState({ recivedData: [] });
                        this.setState({ cashBook: null });
                        this.setState({ selectedRadio: null })
                        this.setState({ loading: false });
                        this.props.alert.success(res.data.msg);

                        console.log("res.data.transHeaderId : " + res.data.transHeaderId);

                        // cash transaction report
                        var path = null;
                        axios.get(window.reportServer + '/cashTransactionReport/getCashTrasactionReport', {
                            // axios.get('http://localhost:5008/cashTransactionReport/get/payment', {
                            params: {
                                id: res.data.transHeaderId
                            }
                        }).then(response => {
                            console.log('get payment cash path', response);

                            path = response.data.path;
                            path = window.reportServer + "/" + path;
                            const url = path;
                            console.log(path)
                            window.open(url, '_blank');
                        }).catch((error) => {
                            if (error) {
                                console.log('get Cash transaction Report error', error);
                            }
                        });
                    }

                    else {
                        this.setState({ loading: false });
                        this.props.alert.error(res.data.msg);
                    }

                }).catch(function (error) {
                    console.log("err " + error);
                });
        }

        else {

            if (!this.state.transactionData.transactionDate) {

                this.props.alert.error("Transaction Date Required");
            }
            else if (!this.state.transactionData.cashBook) {

                this.props.alert.error("Cash Book Required");
            }
            else if (!this.state.transactionData.type) {

                this.props.alert.error("Transaction Type Required");
            }
        }
    }

    draftTransaction = () => {

        if (this.state.transactionData.transactionDate && this.state.transactionData.cashBook && this.state.transactionData.type && this.state.transactionData.docNumber) {

            this.setState({ loading: true });

            axios.post(window.accountServer + '/ledgerAccount/draftCashTransaction', this.state.transactionData)
                .then(res => {

                    if (res.data.status) {
                        this.getDrafts();
                        this.setState({ loading: false });
                        this.props.alert.success(res.data.msg);
                    }

                    else {
                        this.getDrafts();
                        this.setState({ loading: false });
                        this.props.alert.error(res.data.msg);
                    }

                }).catch(function (error) {
                    console.log("err " + error);
                });
        }

        else {

            if (!this.state.transactionData.transactionDate) {

                this.props.alert.error("Transaction Date Required");
            }
            else if (!this.state.transactionData.cashBook) {

                this.props.alert.error("Cash Book Required");
            }
            else if (!this.state.transactionData.type) {

                this.props.alert.error("Transaction Type Required");
            }
            else if (!this.state.transactionData.docNumber) {

                this.props.alert.error("Document No Required");
            }
        }
    }

    getDrafts = () => {


        this.setState({ loading: true });
        this.setState({ draftData: [] });

        axios.get(window.accountServer + '/ledgerAccount/getDraftCashTransaction', this.state.transactionData)
            .then(res => {

                var tmpArray = [];

                for (let i = 0; res.data.length > i; i++) {

                    let data = JSON.parse(res.data[i].DRAFT_DATA);

                    let element = {
                        draftData: data,
                        draftDate: res.data[i].CREATED_DATE.substring(0, 10),
                        draftCode: data.docNumber

                    }

                    tmpArray.push(element);

                }

                this.setState({ draftData: tmpArray });

            }).catch(function (error) {
                console.log("err " + error);
            });

    }

    loadDraftDetails = (data) => {

        this.setState({ transactionData: data });
        this.setState({ spentData: data.spentData });
        this.setState({ recivedData: data.recivedData });
        this.setState({ cashBook: data.cashBook });
        this.setState({ selectedRadio: data.type })
    }


    removeLedgerConfirm = (type, element) => {

        confirmAlert({
            title: 'Confirm to Remove',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.removeLedger(type, element)
                },
                {
                    label: 'No'
                }
            ]
        })
    }

    removeLedger = (type, element) => {

        if (type == 'spent') {

            var tmpArray = [...this.state.spentData]; // make a separate copy of the array
            var index = tmpArray.indexOf(element)
            tmpArray.splice(index, 1);
            this.setState({ spentData: tmpArray });
        }

        if (type == 'received') {

            var tmpArray = [...this.state.recivedData]; // make a separate copy of the array
            var index = tmpArray.indexOf(element)
            tmpArray.splice(index, 1);
            this.setState({ recivedData: tmpArray });
        }

    }


    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return (

                <Loader />

            );
        }
        else {

            return (

                <React.Fragment>

                    <Toolbar className="flex flex-wrap pt-24 px-12">
                        <h2 className="subtitle-color subtitle-margin w-full sm:w-1/4">
                            Cash Transaction
                        </h2>
                    </Toolbar>

                    <div className="block p-20">

                        <div className="w-full sm:w-1/2 md:w-2/5 p-8  inline-block float-right">
                            Document Recall
                                <ReactTable
                                className={classNames(classes.root, "-striped -highlight")}
                                getTrProps={(state, rowInfo, column) => {
                                    return {
                                        className: "cursor-pointer",
                                        onClick: (e, handleOriginal) => {
                                            if (rowInfo) {
                                                this.loadDraftDetails(rowInfo.original.draftData);
                                            }
                                        }
                                    }
                                }}
                                data={this.state.draftData}
                                columns={[
                                    {
                                        Header: "Document No",
                                        accessor: "draftCode",
                                    },
                                    {
                                        Header: "Date",
                                        accessor: "draftDate",
                                    },

                                ]}
                                defaultPageSize={2}
                                noDataText="No Drafts found"
                            />
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block float-right">

                            <TextField
                                type="text"
                                className=" py-8"
                                label="Document Number"
                                value={this.state.transactionData.docNumber}
                                onChange={(ev) => {
                                    ev.stopPropagation();
                                    this.pushData(ev, 'docNumber');
                                }}
                            />
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                            <Typography variant="caption">Transaction Date</Typography>
                            <TextField
                                type="date"
                                className=" py-8"
                                value={this.state.transactionData.transactionDate}
                                onChange={(ev) => {
                                    ev.stopPropagation();
                                    this.pushData(ev, 'transactionDate');
                                }}

                            />
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                            <TextField
                                type="text"
                                className=" py-8"
                                label="Transaction Code"
                                value={this.state.transactionData.transactionCode}
                                onChange={(ev) => {
                                    ev.stopPropagation();
                                    this.pushData(ev, 'transactionCode');
                                }}
                            />
                        </div>
                        <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                            <TextField
                                type="text"
                                className=" py-8"
                                value={this.state.transactionData.referance}
                                label="Referance"
                                onChange={(ev) => {
                                    ev.stopPropagation();
                                    this.pushData(ev, 'referance');
                                }}
                            />
                        </div>

                        <div className="w-full sm:w-1/2 md:w-1/5 pl-12 inline-block">
                            <FormControlLabel
                                //className="md:mb-24 sm:mb-0"
                                control={
                                    <Radio
                                        checked={this.state.selectedRadio === 'spent'}
                                        onChange={this.handleRadioChange}
                                        value="spent"
                                        name="spent"
                                        color="default"
                                    />
                                }
                                label="Spent Money"
                            />
                            <FormControlLabel
                                //className="md:mb-24 sm:mb-0"
                                control={
                                    <Radio
                                        checked={this.state.selectedRadio === 'recieved'}
                                        onChange={this.handleRadioChange}
                                        value="recieved"
                                        name="recieved"
                                        color="default"
                                    />
                                }
                                label="Recieved Money"
                            />
                        </div>

                        <div className="w-full sm:w-1/2 md:w-1/5 inline-block">

                            <Select
                                className=""
                                name="cashBook"
                                placeholder="Search Cash Book"
                                value={this.state.cashBook}
                                onChange={this.handleCashBook}
                                options={this.state.cashBookList}
                            />
                        </div>


                    </div>

                    {this.state.selectedRadio == 'spent' ? (

                        <Formsy
                            onValidSubmit={this.addSpent}
                            id="spentForm"
                        >
                            <div className="block cash-trans-serch-margin">
                                <div className="w-full sm:w-1/2 md:w-1/5  inline-block">

                                    <Select
                                        className=" p-8"
                                        placeholder="Search Ledger Account"
                                        value={this.state.ledgerAccount}
                                        onChange={this.handleLedgerAccount}
                                        options={this.state.ledgerAccounts}
                                    />
                                    <TextFieldFormsy
                                        type="hidden"
                                        className=" p-8"
                                        name="ledgerAccount"
                                        value={this.state.ledgerAccount}
                                    />
                                </div>                                
                            </div>

                           <div className="block cash-trans-form-margin">
                           <div className="w-full sm:w-1/2 md:w-1/5  inline-block">

                                    <TextFieldFormsy
                                        type="text"
                                        className="  p-8"
                                        name="payee"
                                        label="Payee"
                                    />
                                </div>

                                <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                    <TextFieldFormsy
                                        type="text"
                                        className="  p-8"
                                        name="description"
                                        label="Description"
                                    />
                                </div>
                                <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                    <TextFieldFormsy
                                        type="text"
                                        className="  p-8"
                                        name="amount"
                                        label="Amount"
                                    />
                                </div>
                                <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                    <Button
                                        type="submit"
                                        className="w-1/5 mx-12"
                                        variant="raised"
                                        color="secondary"
                                        size="small"

                                    >
                                        Add
                                     </Button>
                                </div>
                           </div>  

                            <div className="block p-20">
                                <ReactTable
                                    className={classNames(classes.root, "-striped -highlight")}
                                    getTrProps={(state, rowInfo, column) => {
                                        return {
                                            className: "cursor-pointer",

                                        }
                                    }}
                                    data={this.state.spentData}
                                    columns={[
                                        {
                                            Header: "Payee",
                                            accessor: "payee",
                                        },
                                        {
                                            Header: "Ledger Account",
                                            Cell: row => (row.original.ledgerAccount.label)
                                        },
                                        {
                                            Header: "Description",
                                            accessor: "description",
                                        },
                                        {
                                            Header: "Amount",
                                            accessor: "amount",
                                            className: "justify-end",
                                            Cell: row => (new Intl.NumberFormat().format((parseFloat(row.original.amount).toFixed(2)))),
                                            Footer: (
                                                <span
                                                    className="justify-end"
                                                >
                                                    <strong>Total:</strong>{" "}
                                                    {_.sum(_.map(this.state.transactionData.spentData, d => parseFloat(parseFloat(d.amount).toFixed(2))))}
                                                </span>
                                            )
                                        },
                                        {
                                            Header: "",
                                            width: 128,
                                            Cell: row => (
                                                <div className="flex items-center">
                                                    <IconButton
                                                        onClick={(ev) => {
                                                            this.removeLedgerConfirm('spent', row.original);
                                                        }}
                                                    >
                                                        <Icon>delete</Icon>
                                                    </IconButton>
                                                </div>
                                            )
                                        },

                                    ]}
                                    defaultPageSize={3}
                                    noDataText="No Records found"
                                />
                            </div>


                            <DialogActions className="justify-right p-20">

                                <FormControlLabel
                                    //className="md:mb-24 sm:mb-0"
                                    control={
                                        <Checkbox
                                            disabled
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.roundUpSpentData(ev);
                                            }}
                                        />
                                    }
                                    label="Roundup"
                                />
                                <Button
                                    variant="raised"
                                    color="secondary"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.addTransaction();
                                    }}
                                >
                                    Save
                          </Button>
                                <Button
                                    type="reset"
                                    variant="raised"
                                    color="default"
                                    onClick={(ev) => {
                                        this.setState({ spentData: [] });
                                        var tmpArray = { ...this.state.transactionData };
                                        tmpArray['spentData'] = [];
                                        this.setState({ transactionData: tmpArray });
                                        this.clearState();
                                    }}
                                >
                                    Clear
                          </Button>
                                <Button

                                    variant="raised"
                                    color="primary"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.draftTransaction();
                                    }}
                                >
                                    Draft
                          </Button>
                                <Button
                                    variant="raised"
                                    color="default"
                                >
                                    Help
                          </Button>
                            </DialogActions>
                        </Formsy>
                    ) :
                        this.state.selectedRadio == 'recieved' ? (



                            <Formsy
                                onValidSubmit={this.addRecived}
                                id="recievedForm"
                            >
                                <div className="block p-20">
                                    <div className="w-full sm:w-1/2 md:w-1/5  inline-block">

                                        <Select
                                            className=" p-8"
                                            placeholder="Search Ledger Account"
                                            value={this.state.ledgerAccount}
                                            onChange={this.handleLedgerAccount}
                                            options={this.state.ledgerAccounts}
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            className=" py-8"
                                            name="ledgerAccount"
                                            value={this.state.ledgerAccount}
                                        />
                                    </div>
                                    <div className="w-full sm:w-1/2 md:w-1/5  inline-block">

                                        <TextFieldFormsy
                                            type="text"
                                            className=" py-8"
                                            name="payer"
                                            label="Payer"
                                        />
                                    </div>

                                    <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                        <TextFieldFormsy
                                            type="text"
                                            className=" py-8"
                                            name="description"
                                            label="Description"
                                        />
                                    </div>
                                    <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                        <TextFieldFormsy
                                            type="text"
                                            className=" py-8"
                                            name="amount"
                                            label="Amount"
                                        />
                                    </div>
                                    <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                        <Button
                                            type="submit"
                                            className="w-1/4 mx-12"
                                            variant="raised"
                                            color="secondary"
                                            size="small"

                                        >
                                            Add
                    </Button>
                                    </div>
                                </div>
                                <div className="block p-20">
                                    <ReactTable
                                        className={classNames(classes.root, "-striped -highlight")}
                                        getTrProps={(state, rowInfo, column) => {
                                            return {
                                                className: "cursor-pointer",

                                            }
                                        }}
                                        data={this.state.recivedData}
                                        columns={[
                                            {
                                                Header: "Payer",
                                                accessor: "payer",
                                            },
                                            {
                                                Header: "Ledger Account",
                                                Cell: row => (row.original.ledgerAccount.label)
                                            },
                                            {
                                                Header: "Description",
                                                accessor: "description",
                                            },
                                            {
                                                Header: "Amount",
                                                accessor: "amount",
                                                className: "justify-end",
                                                Cell: row => (new Intl.NumberFormat().format((parseFloat(row.original.amount).toFixed(2)))),
                                                Footer: (
                                                    <span className="float-right">
                                                        <strong>Total:</strong>{" "}
                                                        {_.sum(_.map(this.state.transactionData.recivedData, d => parseFloat(parseFloat(d.amount).toFixed(2))))}
                                                    </span>
                                                )
                                            },
                                            {
                                                Header: "",
                                                width: 128,
                                                Cell: row => (
                                                    <div className="flex items-center">
                                                        <IconButton
                                                            onClick={(ev) => {
                                                                this.removeLedgerConfirm('received', row.original);
                                                            }}
                                                        >
                                                            <Icon>delete</Icon>
                                                        </IconButton>
                                                    </div>
                                                )
                                            },

                                        ]}
                                        defaultPageSize={3}
                                        noDataText="No Records found"
                                    />
                                </div>


                                <DialogActions className="justify-right p-20">

                                    <FormControlLabel
                                        //className="md:mb-24 sm:mb-0"
                                        control={
                                            <Checkbox
                                                disabled
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.roundUpRecievedData(ev);
                                                }}
                                            />
                                        }
                                        label="Roundup"
                                    />
                                    <Button
                                        variant="raised"
                                        color="secondary"
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.addTransaction();
                                        }}
                                    >
                                        Save
                          </Button>
                                    <Button
                                        type="reset"
                                        variant="raised"
                                        color="default"
                                        onClick={(ev) => {
                                            this.setState({ recivedData: [] });
                                            var tmpArray = { ...this.state.transactionData };
                                            tmpArray['recivedData'] = [];
                                            this.setState({ transactionData: tmpArray });
                                            this.clearState();

                                        }}
                                    >
                                        Clear
                          </Button>
                                    <Button

                                        variant="raised"
                                        color="primary"
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.draftTransaction();
                                        }}
                                    >
                                        Draft
                          </Button>
                                    <Button
                                        variant="raised"
                                        color="default"
                                    >
                                        Help
                          </Button>
                                </DialogActions>
                            </Formsy>
                        ) :
                            ("")
                    }





                </React.Fragment>
            );
        }
    }

    componentWillMount() {

        this.loadLedgerAccounts(2);
        this.loadLedgerAccounts('all');
        this.getDrafts();

    }
}

export default withStyles({ withTheme: true })(withRouter(connect()(withAlert(cashTransaction))));


// WEBPACK FOOTER //
// ./src/main/content/accounting/cashTransaction/cashTransaction.js